import { css } from '@emotion/react';
import { type FC } from 'react';
import { CheckboxComponent } from '~/_shared/baseComponents/checkbox';
import { useTranslation } from '~/_shared/utils/hooks';
import { refreshTokenValidityInDays } from '~/authentication/authContext/auth.utils';

const rememberMeCheckboxStyle = css({ margin: '15px 0' });
const rememberMeTextStyle = css({ fontSize: 18 });

type RememberMeCheckboxProps = Readonly<{
  isChecked: boolean;
  isDisabled: boolean;
  onToggle: () => void;
}>;

export const RememberMeCheckboxComponent: FC<RememberMeCheckboxProps> = (props) => {
  const [t] = useTranslation();

  return (
    <div css={rememberMeCheckboxStyle}>
      <CheckboxComponent
        checkedSetter={props.onToggle}
        isChecked={props.isChecked}
        isDisabled={props.isDisabled}
        text={t('Remember me', { numberOfDays: refreshTokenValidityInDays })}
        textStyle={rememberMeTextStyle}
      />
    </div>
  );
};
